<template>
  <!-- Lazy load the entire slide-in as it's not visible initially -->
  <ClientOnly>
    <SFSlideIn
      :close-on-route-change="false"
      mobile-height="h-full"
      name="FilterSlideIn"
      @close="onSlideInClose"
      @open="onSlideInOpen"
    >
      <template #slide-in-header="{ toggle: toggleItem }">
        <SFFilterHeader :toggle-item="toggleItem" />
      </template>
      <template #slide-in-body>
        <SFFilterSlideInContent
          :category="category"
          :applied-attribute-values="appliedAttributeValues"
          :applied-boolean-values="appliedBooleanValues"
          :applied-filter="appliedFilter"
          :available-filters="availableFilters"
          :hide-sorting="hideSorting"
          @apply-reduction-filter="applyReductionFilter"
          @reset="resetFilter"
          @reset-reduction-filter="resetReductionFilter"
          @apply-price-filter="applyPriceFilter"
          @reset-price-filter="resetPriceFilter"
          @apply-boolean-filter="applyBooleanFilter"
          @apply-attribute-filter="applyAttributeFilter"
        />
      </template>
      <template #slide-in-actions>
        <SFFilterActions
          :are-filters-cleared="areFiltersCleared"
          :filtered-product-count="productsCount"
          @reset="resetFilters"
        />
      </template>
    </SFSlideIn>
  </ClientOnly>
</template>

<script lang="ts" setup>
import type { Category } from '@scayle/storefront-nuxt'
import SFFilterSlideInContent from './SFFilterSlideInContent.vue'
import SFFilterActions from './SFFilterActions.vue'
import SFFilterHeader from './SFFilterHeader.vue'
import { useFilter } from '~/composables'
import { SFSlideIn } from '#storefront-ui/components'
import { useAppliedFilters } from '#storefront-product-listing'
import { useRoute } from '#app/composables/router'
import { ClientOnly } from '#components'

const {
  currentCategoryId,
  hideSorting = false,
  productsCount = 0,
  category,
} = defineProps<{
  category: Category
  currentCategoryId?: number
  productsCount?: number
  hideSorting?: boolean
}>()

const { appliedBooleanValues, appliedFilter, appliedAttributeValues } =
  useAppliedFilters(useRoute())

const {
  onSlideInOpen,
  onSlideInClose,
  applyPriceFilter,
  applyAttributeFilter,
  applyBooleanFilter,
  applyReductionFilter,
  resetPriceFilter,
  resetReductionFilter,
  resetFilters,
  resetFilter,
  areFiltersCleared,
  availableFilters,
} = useFilter(() => currentCategoryId)
</script>
